export class ActionPlan {
  actionPlanId: string = "";
  brandId: string = "";
  dealerId: string = "";
  description: string = "";
  dtCancel: null = null;
  dtClose: null = null;
  dtEnd: number = 0;
  dtInsert: number = 0;
  dtStart: number = 0;
  kpi: string = "";
  kpiActualValue: number = 0;
  kpiGoalValue: number = 0;
  kpiStartValue: number = 0;
  listOutlets: null = null;
  marketId: string = "";
  note: string = "";
  outletId: string = "";
  outletName: string = "";
  regionId: string | null = null;
  sectionValue: string = "";
  status: string = "";
  subRegion: null = null;
  title: string = "";
  usrCancel: null = null;
  usrClose: null = null;
  usrInsert: string = "";
  deleteAction: string = "";
  _id: string = "";
  closeAction = "";
  disabled: boolean;

  constructor(data: ActionPlan) {
    Object.assign(this, data);
    this.kpi = data.kpi + ":title";
    this._id = data.actionPlanId;
    this.disabled = this.status !== "Opened";
    //this.disabled = false;
  }
}
